export interface FaqItemData {
  question: string;
  answer: string;
}

export const faqData: FaqItemData[] = [
  {
    question: "Do I need Shopify to use LendLifted?",
    answer: "No. LendLifted is link and QR based, so you can quote and share financing checkout without moving your business to Shopify."
  },
  {
    question: "How do buyers access financing options?",
    answer: "You share one checkout link or QR code. At checkout, eligible buyers can see monthly payment options supported by Stripe and their selected payment method."
  },
  {
    question: "Do sellers wait for monthly installments?",
    answer: "No. Sellers are paid through normal Stripe settlement timing while buyers repay according to their chosen plan."
  },
  {
    question: "Can I use LendLifted from my phone in person?",
    answer: "Yes. Seller Studio is built for mobile quoting, QR handoff, and SMS follow-up so you can close deals during live conversations."
  }
];
